<template>
  <div
    id="scroll-to-top"
    :class="{ [$style['scroll-to-top']]: true, [$style['scroll-to-top--show']]: showScrollToTop }"
    class="mobile-only"
    @click="scrollToTop()"
  >
    <span><IconSelect icon="chevronUp" /></span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_CONSTANTS from '@/js/plugins/store/modules/app/constants.js'
import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'
import { easeInQuad } from 'vuetify/es5/services/goto/easing-patterns'

export default {
  components: {
    IconSelect,
  },
  computed: {
    ...mapState(STOREMODULES.APP, {
      showScrollToTop: APP_CONSTANTS.SHOW_SCROLL_TO_TOP,
    }),
  },
  methods: {
    scrollToTop() {
      this.$emit('scroll-to-top')
      // window.scrollTo({
      //   top: 0,
      //   left: 0,
      //   behavior: 'smooth',
      // })
      this.$vuetify.goTo(0, {
        duration: 300,
        offset: 0,
        easing: easeInQuad,
      })
    },
  },
}
</script>

<style lang="scss" module>
.scroll-to-top {
  position: fixed;
  right: 1rem;
  bottom: 2rem;
  z-index: 199;

  display: none;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;

  background-color: var(--primary);
  border-radius: 9999px;
  cursor: pointer;

  span {
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: var(--font-xl);

    svg {
      fill: none;
      stroke: var(--white);
      stroke-width: 3;
    }
  }
}

.scroll-to-top.scroll-to-top--show {
  display: flex;
}
</style>
